// src/components/Pages/countryDialCodes.js
export const COUNTRY_DIAL_CODES = [
  { name: "Norway", iso2: "NO", dialCode: "+47" },
  { name: "India", iso2: "IN", dialCode: "+91" },
  { name: "United Kingdom", iso2: "GB", dialCode: "+44" },
  { name: "United States", iso2: "US", dialCode: "+1" },
  { name: "Australia", iso2: "AU", dialCode: "+61" },
  { name: "Austria", iso2: "AT", dialCode: "+43" },
  { name: "Belgium", iso2: "BE", dialCode: "+32" },
  { name: "Brazil", iso2: "BR", dialCode: "+55" },
  { name: "Bulgaria", iso2: "BG", dialCode: "+359" },
  { name: "Canada", iso2: "CA", dialCode: "+1" },
  { name: "Chile", iso2: "CL", dialCode: "+56" },
  { name: "China", iso2: "CN", dialCode: "+86" },
  { name: "Colombia", iso2: "CO", dialCode: "+57" },
  { name: "Costa Rica", iso2: "CR", dialCode: "+506" },
  { name: "Croatia", iso2: "HR", dialCode: "+385" },
  { name: "Cyprus", iso2: "CY", dialCode: "+357" },
  { name: "Czech Republic", iso2: "CZ", dialCode: "+420" },
  { name: "Denmark", iso2: "DK", dialCode: "+45" },
  { name: "Estonia", iso2: "EE", dialCode: "+372" },
  { name: "Finland", iso2: "FI", dialCode: "+358" },
  { name: "France", iso2: "FR", dialCode: "+33" },
  { name: "Germany", iso2: "DE", dialCode: "+49" },
  { name: "Greece", iso2: "GR", dialCode: "+30" },
  { name: "Hong Kong", iso2: "HK", dialCode: "+852" },
  { name: "Hungary", iso2: "HU", dialCode: "+36" },
  { name: "Iceland", iso2: "IS", dialCode: "+354" },
  { name: "Indonesia", iso2: "ID", dialCode: "+62" },
  { name: "Ireland", iso2: "IE", dialCode: "+353" },
  { name: "Israel", iso2: "IL", dialCode: "+972" },
  { name: "Italy", iso2: "IT", dialCode: "+39" },
  { name: "Japan", iso2: "JP", dialCode: "+81" },
  { name: "Kenya", iso2: "KE", dialCode: "+254" },
  { name: "Kuwait", iso2: "KW", dialCode: "+965" },
  { name: "Latvia", iso2: "LV", dialCode: "+371" },
  { name: "Lithuania", iso2: "LT", dialCode: "+370" },
  { name: "Luxembourg", iso2: "LU", dialCode: "+352" },
  { name: "Malaysia", iso2: "MY", dialCode: "+60" },
  { name: "Malta", iso2: "MT", dialCode: "+356" },
  { name: "Mexico", iso2: "MX", dialCode: "+52" },
  { name: "Netherlands", iso2: "NL", dialCode: "+31" },
  { name: "New Zealand", iso2: "NZ", dialCode: "+64" },
  { name: "Nigeria", iso2: "NG", dialCode: "+234" },
  { name: "Pakistan", iso2: "PK", dialCode: "+92" },
  { name: "Philippines", iso2: "PH", dialCode: "+63" },
  { name: "Poland", iso2: "PL", dialCode: "+48" },
  { name: "Portugal", iso2: "PT", dialCode: "+351" },
  { name: "Qatar", iso2: "QA", dialCode: "+974" },
  { name: "Romania", iso2: "RO", dialCode: "+40" },
  { name: "Saudi Arabia", iso2: "SA", dialCode: "+966" },
  { name: "Serbia", iso2: "RS", dialCode: "+381" },
  { name: "Singapore", iso2: "SG", dialCode: "+65" },
  { name: "Slovakia", iso2: "SK", dialCode: "+421" },
  { name: "Slovenia", iso2: "SI", dialCode: "+386" },
  { name: "South Africa", iso2: "ZA", dialCode: "+27" },
  { name: "South Korea", iso2: "KR", dialCode: "+82" },
  { name: "Spain", iso2: "ES", dialCode: "+34" },
  { name: "Sweden", iso2: "SE", dialCode: "+46" },
  { name: "Switzerland", iso2: "CH", dialCode: "+41" },
  { name: "Taiwan", iso2: "TW", dialCode: "+886" },
  { name: "Thailand", iso2: "TH", dialCode: "+66" },
  { name: "Turkey", iso2: "TR", dialCode: "+90" },
  { name: "United Arab Emirates", iso2: "AE", dialCode: "+971" },
  { name: "United Kingdom", iso2: "GB", dialCode: "+44" },
  { name: "United States", iso2: "US", dialCode: "+1" },
  { name: "Vietnam", iso2: "VN", dialCode: "+84" },
  // Add any additional countries you need here:
  { name: "Afghanistan", iso2: "AF", dialCode: "+93" },
  { name: "Albania", iso2: "AL", dialCode: "+355" },
  { name: "Algeria", iso2: "DZ", dialCode: "+213" },
  { name: "Andorra", iso2: "AD", dialCode: "+376" },
  { name: "Angola", iso2: "AO", dialCode: "+244" },
  { name: "Argentina", iso2: "AR", dialCode: "+54" },
  { name: "Armenia", iso2: "AM", dialCode: "+374" },
  { name: "Azerbaijan", iso2: "AZ", dialCode: "+994" },
  { name: "Bahamas", iso2: "BS", dialCode: "+1" },
  { name: "Bahrain", iso2: "BH", dialCode: "+973" },
  { name: "Bangladesh", iso2: "BD", dialCode: "+880" },
  { name: "Barbados", iso2: "BB", dialCode: "+1" },
  { name: "Belarus", iso2: "BY", dialCode: "+375" },
  { name: "Bolivia", iso2: "BO", dialCode: "+591" },
  { name: "Bosnia and Herzegovina", iso2: "BA", dialCode: "+387" },
  { name: "Botswana", iso2: "BW", dialCode: "+267" },
  { name: "Brunei", iso2: "BN", dialCode: "+673" },
  { name: "Cambodia", iso2: "KH", dialCode: "+855" },
  { name: "Cameroon", iso2: "CM", dialCode: "+237" },
  { name: "Cape Verde", iso2: "CV", dialCode: "+238" },
  { name: "Dominican Republic", iso2: "DO", dialCode: "+1" },
  { name: "Ecuador", iso2: "EC", dialCode: "+593" },
  { name: "Egypt", iso2: "EG", dialCode: "+20" },
  { name: "El Salvador", iso2: "SV", dialCode: "+503" },
  { name: "Ethiopia", iso2: "ET", dialCode: "+251" },
  { name: "Fiji", iso2: "FJ", dialCode: "+679" },
  { name: "Georgia", iso2: "GE", dialCode: "+995" },
  { name: "Ghana", iso2: "GH", dialCode: "+233" },
  { name: "Guatemala", iso2: "GT", dialCode: "+502" },
  { name: "Honduras", iso2: "HN", dialCode: "+504" },
  { name: "Iran", iso2: "IR", dialCode: "+98" },
  { name: "Iraq", iso2: "IQ", dialCode: "+964" },
  { name: "Jamaica", iso2: "JM", dialCode: "+1" },
  { name: "Jordan", iso2: "JO", dialCode: "+962" },
  { name: "Kazakhstan", iso2: "KZ", dialCode: "+7" },
  { name: "Lebanon", iso2: "LB", dialCode: "+961" },
  { name: "Liechtenstein", iso2: "LI", dialCode: "+423" },
  { name: "Macao", iso2: "MO", dialCode: "+853" },
  { name: "Madagascar", iso2: "MG", dialCode: "+261" },
  { name: "Morocco", iso2: "MA", dialCode: "+212" },
  { name: "Mozambique", iso2: "MZ", dialCode: "+258" },
  { name: "Nepal", iso2: "NP", dialCode: "+977" },
  { name: "Nicaragua", iso2: "NI", dialCode: "+505" },
  { name: "North Macedonia", iso2: "MK", dialCode: "+389" },
  { name: "Norway", iso2: "NO", dialCode: "+47" },
  { name: "Oman", iso2: "OM", dialCode: "+968" },
  { name: "Panama", iso2: "PA", dialCode: "+507" },
  { name: "Paraguay", iso2: "PY", dialCode: "+595" },
  { name: "Peru", iso2: "PE", dialCode: "+51" },
  { name: "Puerto Rico", iso2: "PR", dialCode: "+1" },
  { name: "Russia", iso2: "RU", dialCode: "+7" },
  { name: "Rwanda", iso2: "RW", dialCode: "+250" },
  { name: "Senegal", iso2: "SN", dialCode: "+221" },
  { name: "Sri Lanka", iso2: "LK", dialCode: "+94" },
  { name: "Suriname", iso2: "SR", dialCode: "+597" },
  { name: "Tanzania", iso2: "TZ", dialCode: "+255" },
  { name: "Togo", iso2: "TG", dialCode: "+228" },
  { name: "Tunisia", iso2: "TN", dialCode: "+216" },
  { name: "Uganda", iso2: "UG", dialCode: "+256" },
  { name: "Ukraine", iso2: "UA", dialCode: "+380" },
  { name: "Uruguay", iso2: "UY", dialCode: "+598" },
  { name: "Uzbekistan", iso2: "UZ", dialCode: "+998" },
  { name: "Venezuela", iso2: "VE", dialCode: "+58" },
  { name: "Zambia", iso2: "ZM", dialCode: "+260" },
  { name: "Zimbabwe", iso2: "ZW", dialCode: "+263" },
];
